import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrowDouble-d",
  "use": "arrowDouble-d-usage",
  "viewBox": "0 0 17.98 16.9",
  "content": "<symbol viewBox=\"0 0 17.98 16.9\" id=\"arrowDouble-d\"><title>资源 4</title><g id=\"arrowDouble-d_图层_2\" data-name=\"图层 2\"><g id=\"arrowDouble-d_图层_1-2\" data-name=\"图层 1\"><path d=\"M17.69.28a1,1,0,0,0-1.39,0L9,7.64,1.68.36A1,1,0,0,0,0,1.06a1,1,0,0,0,.29.7l8,8a1,1,0,0,0,1.39,0l8-8A1,1,0,0,0,17.69.28Z\" /><path d=\"M17.69,7.18a1,1,0,0,0-1.39,0L9,14.53,1.68,7.25A1,1,0,1,0,.29,8.66l8,8a1,1,0,0,0,1.39,0l8-8A1,1,0,0,0,17.69,7.18Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrowDouble-d.svg
// module id = kV/y
// module chunks = 264